/* eslint-disable default-case */
import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  labelStyle,
  tooltip,
  responsiveFun,
  stroke,
  lineXaxis,
  markers,
} from './options';
import dict from '../dictionary';
import ReducedData from '../reducedData.json';
import trans from '../translations.json';
import { DownloadButton } from './options';
import StackedTable from './hospital-table';

import { ButtonGroup } from './buttonGroup/buttonGroup';
import LegandCheckbox from './legandCheckbox/legandCheckbox';
const viewModes = {
  graph: 'graph',
  table: 'table',
};

const colors = ['#d5b758', '#594a17'];

class Hospital extends Component {
  state = {
    ready: false,
    dates: [],
    series: [],
    options: {},
    selectedViewMode: viewModes.graph,
    chartRef: React.createRef(null),
  };

  toggle = (name) => {
    this.state.chartRef.current.chart.toggleSeries(name);
    if (this.state.chartRef.current.chart.series.w.globals.noData) {
      this.state.chartRef.current.chart.updateOptions({
        xaxis: {
          labels: {
            show: false,
          },
        },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text =
            trans.casesTotal.yaxis[this.props.lang];
          item.options.xaxis = {
            labels: {
              show: false,
            },
          };
          return item;
        }),
      });
    } else {
      this.state.chartRef.current.chart.updateOptions({
        xaxis: {
          labels: {
            show: true,
          },
        },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text =
            trans.casesTotal.yaxis[this.props.lang];
          item.options.xaxis = {
            labels: {
              show: true,
            },
          };
          return item;
        }),
      });
    }
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  componentDidMount() {
    this.setData();
  }

  setData = () => {
    var covidData = ReducedData.covidData;
    const datz = [...covidData].filter(
      (item) => item[dict.patientHospitalizedCOVID19],
    );

    var notICU = datz.map((item) => {
      return [
        item[dict.reportedDate],
        item[dict.patientHospitalizedCOVID19],
      ];
    });

    var ICUwov = datz.map((item) => {
      return [
        item[dict.reportedDate],
        item[dict.patientsICUwCOVID19],
      ];
    });

    this.setState({
      series: [
        {
          name: trans.hospital.hospitalicu[this.props.lang],
          data: notICU,
          type: 'bar',
        },
        {
          name: trans.hospital.icu[this.props.lang],
          data: ICUwov,
        },
        // {
        //   name: trans.hospital.icuv[this.props.lang],
        //   data: ICUwithv,
        // },
      ],
      options: {
        // title: { text: "Summary of Cases in Ontario" },
        colors: colors,
        markers: markers,
        stroke: stroke,
        legend: {
          show: false,
        },
        tooltip: tooltip,
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          id: 'Hospital',
          //type: "line",
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: { enabled: true },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: trans.casesTotal.yaxis[this.props.lang],
          },
          labels: {
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            style: { ...labelStyle },
          },
        },
        xaxis: { ...lineXaxis(true) },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text =
            trans.casesTotal.yaxis[this.props.lang];
          item.options.xaxis = { ...lineXaxis(true) };
          return item;
        }),
        fill: {
          opacity: [0.2, 1],
        },
      },
      ready: true,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <LegandCheckbox
                series={this.state.series}
                colours={colors}
                toggle={this.toggle}
              />
              <ReactApexChart
                ref={this.state.chartRef}
                options={this.state.options}
                series={this.state.series}
                height="400px"
                aria-hidden="true"
              />
            </>
          );
        case viewModes.table:
          return <StackedTable lang={this.props.lang} />;
      }
    };

    return (
      <div id="">
        {this.state.ready && (
          <>
            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />
            <GetRightView />
          </>
        )}
      </div>
    );
  }
}
export default Hospital;
